import { render, staticRenderFns } from "./ScoreList.vue?vue&type=template&id=29808b4a&scoped=true&"
import script from "./ScoreList.vue?vue&type=script&lang=js&"
export * from "./ScoreList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreList.vue?vue&type=style&index=0&id=29808b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29808b4a",
  null
  
)

export default component.exports